/**
 * Checks if the given keyboard event corresponds to an activation key.
 *
 * Activation keys include:
 * - Enter (`'Enter'`)
 * - Space (`' '` or `'Space'` or keyCode `32`)
 *
 * @param e - The keyboard event to check.
 * @returns `true` if the key is an activation key, otherwise `false`.
 */
export const isActivationKey = e =>
  e.key === 'Enter' || e.key === ' ' || e.code === 'Space' || e.keyCode === 32;
